import { PRIVATE_CONTROLLERS } from './common/private-controllers';
export var fullscreenOptions = [
    {
        FULLSCREEN_INFO_SETTINGS: [
            PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_TITLE,
            PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_DESCRIPTION,
            PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_LINK,
            PRIVATE_CONTROLLERS.FULLSCREEN.EXPAND_INFO_POSITION,
            PRIVATE_CONTROLLERS.FULLSCREEN.SHOW_INFO_BUTTON,
        ],
        FULLSCREEN_VIEWING_SETTINGS: [
            PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_FULLSCREEN_EXPAND,
            // PRIVATE_CONTROLLERS.FULLSCREEN.LOOP,
            PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_MAGNIFY_IMAGE,
            PRIVATE_CONTROLLERS.FULLSCREEN.MAGNIFICATION_LEVEL,
        ],
        FULLSCREEN_BACKGROUND_FILTERS: [
            PRIVATE_CONTROLLERS.FULLSCREEN.BACKGROUND_BLUR_FILTER,
            PRIVATE_CONTROLLERS.FULLSCREEN.BACKGROUND_GRAYSCAL_EFILTER
        ],
    },
    PRIVATE_CONTROLLERS.FULLSCREEN.FULLSCREEN_PREVIEW,
];
//# sourceMappingURL=fullscreenOptions.js.map